module.exports = __webpack_public_path__ + "img/globe.bf5bf130.svg";